import axios from 'axios';

axios.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'multipart/form-data'
  return config;

}, (error) => {
  console.log('網路異常');
  return Promise.reject(error);
});

axios.interceptors.response.use(res => { 
  return res
}, (error) => {

  return Promise.reject(error);

});

export default axios;
